import { makeAutoObservable, runInAction } from 'mobx';
import type { ResponseDataRow } from 'ksnm-common-ui/lib/Table2/utils/TableRequest';

import { cmApi } from '@src/api';
import { preloaderStore } from '@stores/preloaderStore';
import type { CmApi, ReportGroupsDto } from '@src/api';

export type ReportGroupsDtoDefId = Omit<ReportGroupsDto, 'id' | 'code'> & { id: string; code: string };

class ReportGroupsStore {
  reportGroups: ReportGroupsDtoDefId[] = [];

  api: CmApi;

  checked: ResponseDataRow[] = [];

  isChanged = false; // флаг, что справочник изменился для проверки загрузки в fetchReferences

  constructor({ api }: { api: CmApi }) {
    this.api = api;
    makeAutoObservable(this);
  }

  setIsChanged = (value: boolean) => {
    this.isChanged = value;
  };

  setChecked = (value) => {
    this.checked = value;
  };

  fetch = async (): Promise<void> => {
    preloaderStore.preloader(true);
    const { data } = await this.api.reportGroups.getReportGroups();

    runInAction(() => {
      this.reportGroups = data?.map((item) => ({ ...item, id: item.code })) ?? [];
      this.isChanged = false;
    });
    preloaderStore.preloader(false);
  };

  groupDelete = async (reportGroups: ReportGroupsDtoDefId[]) => {
    preloaderStore.preloader(true, 'удаление...');
    const deleteCode = reportGroups.map((report) => report.code);
    await this.api.reportGroups.deleteReportGroup(deleteCode);
    await this.fetch();
    preloaderStore.preloader(false);
  };

  clear = () => {
    this.checked = [];
  };
}

export const reportGroupsStore = new ReportGroupsStore({ api: cmApi });
